import { Image } from "@mui/icons-material";
import { Box, ButtonBase, Chip, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import Carousel from "react-material-ui-carousel";
import { useAppSelector } from "store/appHooks";

const DetailsImageGridOwner = () => {
  const { listingDetailsOwner }: any = useAppSelector(
    (state) => state.searchListingReducer
  );
  const [images, setImages] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const handleSlideChange = (index: number) => {
    setActiveIndex(index); // Update the activeIndex state
  };
  useEffect(() => {
    setImages(
      listingDetailsOwner?.images?.length > 4 && !showAll
        ? listingDetailsOwner?.images.slice(0, 4)
        : listingDetailsOwner?.images
    );
  }, [listingDetailsOwner?.images, showAll]);
  const handleShowAll = () => setShowAll(!showAll);

  return (
    <Box>
      <Box
        sx={{
          display: {
            md: "block",
            lg: "block",
            xl: "block",
            sm: "none",
            xs: "none",
          },
          pl: "1.5%",
          py: "20px",
          position: "relative",
        }}
      >
        <Grid container spacing={1}>
          {images?.map((img: any) => (
            <Grid item sm={6} md={6} lg={6} xl={6}>
              <img
                src={img.preview_url}
                alt=""
                width="100%"
                height="368px"
                style={{ borderRadius: "10px" }}
              />
            </Grid>
          ))}
        </Grid>
        {listingDetailsOwner?.images?.length > 4 && (
          <Box
            sx={{
              position: "absolute",
              margin: "auto",
              display: "flex",
              justifyContent: "center",
              bottom: "-14px",
              width: "100%",
            }}
          >
            <ButtonBase
              onClick={handleShowAll}
              sx={{
                background: "#FFF",
                border: "1px solid #E2E2E2",
                height: "64px",
                width: "184px",
                borderRadius: "5rem",
                ...(showAll
                  ? {
                      img: {
                        transform: "rotate(180deg)",
                      },
                    }
                  : {}),
              }}
            >
              <Typography
                sx={{ color: "#323232", fontWeight: 600, fontSize: "15px" }}
              >
                {showAll ? `Show Less` : `Show More`}
              </Typography>
              &nbsp;&nbsp;&nbsp;
              <img src="/assets/img/icons/down_arrow.svg" alt="" />
            </ButtonBase>
          </Box>
        )}
      </Box>
      <Box
        sx={{
          display: {
            md: "none",
            lg: "none",
            xl: "none",
            sm: "block",
            xs: "block",
          },
          height: "264px !important",
          position: "relative",
        }}
      >
        <Carousel
          animation="slide"
          indicators={false}
          navButtonsAlwaysVisible={false}
          navButtonsAlwaysInvisible={false}
          cycleNavigation={true}
          fullHeightHover={false}
          autoPlay={false}
          onChange={(now: any) => handleSlideChange(now)}
        >
          {listingDetailsOwner?.images?.map((img: any) => (
            <img
              src={img.preview_url}
              alt=""
              width="100%"
              height="264px"
              style={{ borderRadius: "10px" }}
            />
          ))}
        </Carousel>
        <Box
          sx={{
            position: "absolute",
            width: "fit-content",
            top: "10px",
            zIndex: 4,
            right: "10px",
          }}
        >
          <Chip
            label={`${activeIndex + 1}/${listingDetailsOwner?.images?.length}`}
            sx={{ background: "#323232", color: "#FFF", fontWeight: 600 }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default DetailsImageGridOwner;
